namespace TabAurous.Administration {
    export interface AuthorizedVouchersForm {
        LoginUserId: Serenity.IntegerEditor;
        AuthorizedUserId: Serenity.IntegerEditor;
        VoucherNo: Serenity.StringEditor;
        VoucherTypeId: Serenity.IntegerEditor;
        AuthorizationDate: Serenity.DateEditor;
        Remark: Serenity.StringEditor;
    }

    export class AuthorizedVouchersForm extends Serenity.PrefixedContext {
        static formKey = 'Administration.AuthorizedVouchers';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!AuthorizedVouchersForm.init)  {
                AuthorizedVouchersForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.StringEditor;
                var w2 = s.DateEditor;

                Q.initFormType(AuthorizedVouchersForm, [
                    'LoginUserId', w0,
                    'AuthorizedUserId', w0,
                    'VoucherNo', w1,
                    'VoucherTypeId', w0,
                    'AuthorizationDate', w2,
                    'Remark', w1
                ]);
            }
        }
    }
}
